import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, crudUpdateMany, translate } from 'react-admin';

class MoveToPreapprovedButton extends Component {
    handleClick = () => {
        const { basePath, crudUpdateMany, resource, selectedIds } = this.props;
        crudUpdateMany(resource, selectedIds, { status: 'preapproved' }, basePath);
    };

    render() {
        return (
            <Button label={this.props.translate(`resources.payments.moveto.preapproved`)} onClick={this.handleClick} />
        );
    }
}

export default translate(connect(undefined, { crudUpdateMany })(MoveToPreapprovedButton));